// extracted by mini-css-extract-plugin
module.exports = {"root":"GuideBlock_root__4vFEw","textWrapper":"GuideBlock_textWrapper__iXe_I"};